import { Component, Input, OnDestroy, OnInit } from "@angular/core";
import { Store } from "@ngrx/store";
import { selectInfo } from "projects/money-movement-ui/src/app/account-info-header/reducers";
import { accountDetailsLabel, fromAccountDetailsLabel, pageInContext } from "projects/money-movement-ui/src/app/shared/utilities/Constants";
import { combineLatest, Subject, takeUntil } from "rxjs";
import { HyphenatedPipe } from "projects/money-movement-ui/src/app/shared/pipes/HyphenatedPipe";
import { selectConfirmationPageTaxId, selectViewAccountDetails, selectViewInContext, selectViewPageTaxId } from "../../../../reducers";
import { selectIsTransactionsViewPage } from "projects/money-movement-ui/src/app/transaction-view/reducers";

@Component({
  standalone: false,
    selector: 'mm-from-account-details-condensed',
    templateUrl: './from-account-details-condensed.component.html',
    styleUrls: ['./from-account-details-condensed.component.scss']
})

export class FromAccountDetailsCondensedComponent implements OnInit, OnDestroy {
    @Input() subtitle: string;

    readonly labels = fromAccountDetailsLabel;
    readonly accountDetailsLabels = accountDetailsLabel;

    masterAccount: string;
    accountNumber: string;
    accountType: string;
    primaryAccountHolder: string[] = [];
    currentStep: string;
    taxId: string;
    isTransactionViewPage: boolean;

    destroy$: Subject<boolean> = new Subject<boolean>();

    constructor(private store: Store) {}

    ngOnInit(): void {
        combineLatest([
            this.store.select(selectInfo),
            this.store.select(selectViewAccountDetails)
        ]).pipe(takeUntil(this.destroy$)).subscribe(([info, viewDetails]) => {
            const hyphenatedPipe = new HyphenatedPipe();
            this.masterAccount = hyphenatedPipe.transform(info.masterAccount);
            this.accountNumber = hyphenatedPipe.transform(info.accountId.length > 0 ? info.accountId : viewDetails?.subAccountId ?? '');
            this.accountType = !!info.registrationType ? info.registrationType : viewDetails?.regType ?? '';
            this.primaryAccountHolder = []; // reset primaryAccountHolder before adding properties
            this.primaryAccountHolder.push(info.subAccountNameLine1);
            if (!!info.subAccountNameLine2) {
                this.primaryAccountHolder.push(info.subAccountNameLine2);
            }
            if (!!info.subAccountNameLine3) {
                this.primaryAccountHolder.push(info.subAccountNameLine3);
            }
        });
        this.store.select(selectIsTransactionsViewPage).pipe(takeUntil(this.destroy$)).subscribe(value => this.isTransactionViewPage = value);
        this.store.select(selectViewInContext).pipe(takeUntil(this.destroy$)).subscribe(step => this.currentStep = step);
        if (this.isTransactionViewPage) {
            this.store.select(selectViewPageTaxId).pipe(takeUntil(this.destroy$)).subscribe(value => this.taxId = value);
        } else {
            this.store.select(selectConfirmationPageTaxId).pipe(takeUntil(this.destroy$)).subscribe(value => this.taxId = value);
        }
    }

    get isReviewPage(): boolean {
        return this.currentStep === pageInContext.review
    }

    ngOnDestroy(): void {
        this.destroy$.next(true);
        this.destroy$.complete();
    }
}
